// extracted by mini-css-extract-plugin
export default {"img":"wQMKfF","description":"Dxs5Q3","action":"IL_5Ww","action--with-full-width":"wu2CzK","reject-wrapper":"FalyZQ"};